$(document).ready(function () {
    var bodyActiveClass = 'sidebar-open'
    var activeClass = 'active';
    var parentClass = 'gridelement-sidebar-parent';
    var sidebar = $('#sidebar');
    var sidebarContainer = $('.section.section-default');
    var $document = $(document);

    $('.gridelement-sidebar .sidebar-menu-link').on('click', function () {
        var dataUid = 'uid'
        var dataIndex = 'index'
        var fadeLeftClass = 'fadeLeft';
        var fadeRightClass = 'fadeRight';

        var $this = $(this);
        var parent = $this.parents('.gridelement-sidebar');
        var uid = $this.data(dataUid)
        var index = $this.data(dataIndex)

        parent.data(dataUid, uid).data(dataIndex, index);


        var newChild = parent.children('#sidebar-element-'+uid);
        var oldChild = $(newChild.siblings('.'+activeClass));

        //FADE OUT OLD CHILD
        if(oldChild.data(dataIndex) == 0) {
            oldChild.addClass(fadeLeftClass);
        } else {
            oldChild.addClass(fadeRightClass);
        }
        oldChild.removeClass(activeClass)

        //FADE IN NEW CHILD
        newChild.addClass(activeClass).removeClass(fadeRightClass).removeClass(fadeLeftClass);
        setSidebarHeight(parent);


    })

    function setSidebarHeight($this) {
        var calcHeight = 0;
        $this.find('.sidebar-element.active').children().each(function () {
            calcHeight += $(this).outerHeight();
        })
        $this.height(calcHeight)
    }

    $('.gridelement-sidebar').each(function () {
        setSidebarHeight($(this));
    })

    $('.gridelement-sidebar-icon').on('click', function () {
        var $this = $(this);
        var parent = $this.parent('.'+parentClass)

        parent.toggleClass(activeClass)
        sidebar.find('.'+parentClass).not(parent).removeClass(activeClass);

        if(sidebar.find('.'+parentClass).hasClass(activeClass) == true) {
            sidebar.addClass(activeClass)
            $('body').addClass(bodyActiveClass)
        }else {
            sidebar.removeClass(activeClass)
            $('body').removeClass(bodyActiveClass)
        }
        setSidebarHeight($this.siblings('.gridelement-sidebar'))

    })

    $(document).click(function (event) {
        if(sidebar.hasClass(activeClass) == 1 && $(event.target).parents("#sidebar").length == 0) {
            sidebar.removeClass(activeClass)
            sidebar.find(".gridelement-sidebar-parent."+activeClass).removeClass(activeClass)
            $('body').removeClass(bodyActiveClass)
        }
    });
    
    $('.icon-close').on('click', function () {
        sidebar.removeClass(activeClass)
        $(this).parents('.'+parentClass).removeClass(activeClass)
        $('body').removeClass(bodyActiveClass)
    })


    //MAKE SIDEBAR STICKY
    $(window).scroll(function(event){
        scrollSidebar();
    });
    $( window ).resize(function() {
        scrollSidebar();
    });
    //ready
    scrollSidebar();
    
    function scrollSidebar() {
        var docHeight = $document.scrollTop();
        var sidebarHeight = sidebar.offset().top;
        var sidebarInnerHeight = sidebar.height();
        var sidebarContainerHeight = sidebarContainer.offset().top;
        var sidebarContainerinnerHeight = sidebarContainer.height();

        var stickyMin = sidebarContainerHeight;
        var stickyMax = ((sidebarContainerHeight + sidebarContainerinnerHeight) - sidebarInnerHeight)


        if(docHeight + 100 > stickyMin && docHeight < stickyMax) {
            // MAKE STICKY
            var newHeight = docHeight - sidebarContainerHeight + 150;
            sidebar.css('top', newHeight);

        } else if(docHeight < stickyMin) {
            setSidebarToDefault();
            // SIDEBAR IS OVER DOCUMENT

        } else if(docHeight > stickyMax) {
            // SIDEBAR IS UNDER DOCUMENT
        } else {
            // set default
            setSidebarToDefault();
        }

    }
    function setSidebarToDefault() {
        sidebar.css('top', '35px');
    }

});